import { createFileRoute } from "@tanstack/react-router";
import { PenyediaPage } from "@/components/admin/ai-assistant/penyedia-page";
import { requireAdminFeature } from "@/middleware/admin-feature-guard";

export const Route = createFileRoute("/admin/ai-assistant/penyedia")({
	beforeLoad: requireAdminFeature("admin-ai-penyedia"),
	component: PenyediaPage,
});
